// extracted by mini-css-extract-plugin
module.exports = {"customLink":"succession-overview-table_customLink__1Wr-A","customMonth":"succession-overview-table_customMonth__2LuPU"};